import { useState, useContext } from "react";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
//Import from project
import "../../../Style/actionstyle.scss";
import { AuthContext } from "../../../Context/AuthContext";
import ScheduleForm from "./ScheduleForm"; 
import { useMutation } from "@apollo/client";
import DialogDelete from "../../../Utils/DialogDelete";
import { DELETE_SCHEDULE } from "../../../Schema/Schedule";
export default function ScheduleAction({
  day,
  mainId,
  editData,
  classData,
  setRefetch,
}) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal update
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const [loading, setLoading] = useState(false);

  const [deleteSchedule] = useMutation(DELETE_SCHEDULE, { 
    onCompleted: ({ deleteSchedule }) => {
      console.log("deleteSchedule :", deleteSchedule);
      setLoading(false);
      if (deleteSchedule?.isSuccess === true) {
        setAlert(true, "success", deleteSchedule?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteSchedule?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const handleDelete = () => {
    deleteSchedule({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="right"
        spacing={1}
        sx={{ paddingY: 0.5 }}
      >
        <Tooltip title={t("update")} placement="top">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{ bgcolor: "orange", width: 18, height: 18, borderRadius: 1 }}
          >
            <IconButton onClick={handleOpenEdit}>
              <MdModeEdit style={{ color: "white" }} fontSize={14} />
            </IconButton>
          </Stack>
        </Tooltip>

        <Tooltip title={t("delete")} placement="top">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{ bgcolor: "red", width: 18, height: 18, borderRadius: 1 }}
          >
            <IconButton onClick={handleOpenDel}>
              <MdDelete style={{ color: "white" }} fontSize={14} />
            </IconButton>
          </Stack>
        </Tooltip>
 
      </Stack>

      {openEdit && (
        <ScheduleForm
          dialogTitle={"Update"}
          day={day}
          mainId={mainId}
          open={openEdit}
          classData={classData}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={handleCloseEdit}
        />
      )}
      {openDel && (
        <DialogDelete
          open={openDel}
          loading={loading}
          editData={editData}
          handleClose={handleCloseDel}
          deleteTitle={t("modal_title_delete_schedule")}
          handleDelete={handleDelete}
        />
      )}
    </div>
  );
}
